module.exports = __webpack_public_path__ + "img/Ript90.f28da82f.jpg";